import { FooterProps } from "../../../../models/footer";
import _get from "lodash/get";
import { PartialPick } from "../../../../constants";
import { RootState } from "../../../../models";
import { NavigationState } from "../../../../models/state";

export type State = PartialPick<RootState, "navigation">;
export const getNavigation = (state: State): Partial<NavigationState> => state.navigation || {};
export const shouldHidePageHeader = (state: State): boolean =>
    _get(getNavigation(state), "shouldHidePageHeader", false);
export const shouldHidePageFooter = (state: State): boolean =>
    _get(getNavigation(state), "shouldHidePageFooter", false);
export const shouldHideCartInMenu = (state: State): boolean =>
    _get(getNavigation(state), "shouldHideCartInMenu", false);
export const isGetExistingCustomer = (state: State): boolean =>
    _get(getNavigation(state), "isGetExistingCustomer", false);
export const isGetWelcomeOffer = (state: State): boolean => _get(getNavigation(state), "isGetWelcomeOffer", false);
export const shouldShowGoToCartButton = (state: State): boolean =>
    _get(getNavigation(state), "shouldShowGoToCartButton", true);

export const isNavigating = (state: State): boolean => !!getNavigation(state)?.navigating;
export const getFooterInfo = (state: State): FooterProps | undefined => _get(getNavigation(state), "footerInfo");
export const shouldShowMemberStepWhenReSwitch = (state: State): boolean =>
    _get(getNavigation(state), "shouldShowMemberStepWhenReSwitch", true);
